module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-root-1.83eae87c.svg";